import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { errorToast, successToast } from "@telluscompany/design-system";
import { useLocalization } from "@i18n";
import { axiosPostData } from "@shared/api/clients";
import { PRIVACY_POLICY_QUERY_KEY } from "./privacy-policy.queries";
import { UploadPrivacyPolicyRequest } from "./privacy-policy.types";

const UPLOAD_ENDPOINT = "v1/managerial/legal-documents";
const UPLOAD_TYPE = "PRIVACY POLICY";

export const useUploadPrivacyPolicyMutation = () => {
  const queryClient = useQueryClient();
  const { translate } = useLocalization();

  return useMutation({
    mutationFn: ({ file }: UploadPrivacyPolicyRequest) => {
      const formData = new FormData();
      formData.append("type", UPLOAD_TYPE);
      formData.append("file", file);
      return axiosPostData<void, FormData>(UPLOAD_ENDPOINT, formData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PRIVACY_POLICY_QUERY_KEY });
      successToast({ description: translate("common.createSuccess") });
    },
    onError: (error: AxiosError) => {
      errorToast({ description: error.parsedMessage ?? translate("common.errorCreating") });
    },
  });
};
